// Today's Running Order number, for the buttons that offer it from elsewhere
// (CLAUDE.md: The next-game buttons).
//
// Asked of the server, which knows what today is on UK time; null until it
// answers, and null when there is no daily today -- before launch, say -- in
// which case the button is simply not drawn. Never a filler.
import { useEffect, useState } from 'react';
import { rpc } from '../../lib/api.ts';
import type { RunningOrderBoard } from './types.ts';

let cached: Promise<number | null> | null = null;

/** Today's daily number, or null where there is none. One request per visit. */
export function todaysNumber(): Promise<number | null> {
  cached ??= rpc<RunningOrderBoard | null>('ro_board', { p_number: null })
    .then((b) => b?.number ?? null, () => { cached = null; return null; });
  return cached;
}

/** Forget today's number, for a page left open across UK midnight. */
export function forgetToday(): void { cached = null; }

export function useTodaysRunningOrder(): number | null {
  const [number, setNumber] = useState<number | null>(null);
  useEffect(() => {
    let live = true;
    todaysNumber().then((n) => { if (live) setNumber(n); });
    return () => { live = false; };
  }, []);
  return number;
}
